import React from 'react'

export default function LargeStarIcon(props) {

    return (
        <>
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M4.41095 18.3904L9 15.8684L13.5891 18.3904C14.2496 18.7534 15.0191 18.1624 14.8923 17.3894L14.0173 12.0567L17.725 8.27883C18.2623 7.7314 17.9677 6.77307 17.2276 6.66066L12.0985 5.88159L9.80587 1.02568C9.47494 0.324774 8.52506 0.324774 8.19413 1.02568L5.90147 5.88159L0.772364 6.66066C0.0322975 6.77307 -0.262261 7.7314 0.274997 8.27883L3.9827 12.0567L3.1077 17.3894C2.98088 18.1624 3.75039 18.7534 4.41095 18.3904Z" fill="#FFC542" />
            </svg>

        </>
    )
}
